import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

import { FeatureFlagsProvider } from '../../context/FeatureFlagContext';

import { useAuthRedirect } from '../../hooks/useAuthRedirect';
import { useAuthSession } from '../../hooks/useAuthSession';

const PrivateRoute: React.FC<RouteProps> = ({
    component: Component,
    ...rest
}) => {
    const { isAuthenticated, status } = useAuthSession();

    useAuthRedirect({ isAuthenticated, status });

    if (status === 'loading' || !isAuthenticated) {
        return null;
    }

    return (
        <FeatureFlagsProvider>
            <Route
                {...rest}
                render={(props) =>
                    Component && <Component {...props} {...rest} />
                }
            />
        </FeatureFlagsProvider>
    );
};

export default PrivateRoute;
